<template>
  <div class="container">
    <div class="title-linea">
      <div class="title">Articles Preview</div>
      <div class="linea"></div>
    </div>
    <div class="articles-area">
      <div id="articles" class="articles carousel">
        <div class="article carousel__container">
          <div v-for="item in articles" :key="item.id" class="carousel-item">
            <a :href="`/articles/${item.id}/${item.slug}`">
              <div class="article--item">
                <figure class="article-img">
                  <img
                    class="image"
                    :src="item.imageUrl"
                    click="test(item.id)"
                    :alt="item.title"
                  />
                </figure>
                <div class="article--title">
                  <p>{{ item.title }}</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <button class="icon-carousel icon-prev" @click="prev">
        <font-awesome-icon color="white" icon="chevron-left" />
      </button>
      <button class="icon-carousel icon-next" @click="next">
        <font-awesome-icon color="white" icon="chevron-right" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    params: {
      page: 0,
    },
    articles: [],
  }),
  created() {
    this.$Parse.Cloud.run("getArticles", this.params)
      .then((res) => {
        this.articles = res.items.map(function (obj) {
          const searchRegExp = /\s/g;
          const replaceWith = "-";
          obj.slug = obj.title.replace(searchRegExp, replaceWith);
          return obj;
        });
      })
      .catch((error) => {
        this.articles = error;
      });
  },

  methods: {
    handleClickSlide(index, reallyIndex) {
      this.$router.push(`/articles/${this.articles[reallyIndex].id}`);
    },
    prev: function () {
      let a = document.getElementById("articles").scrollLeft;
      a -= 600;
      document
        .getElementById("articles")
        .scroll({ left: a, behavior: "smooth" });
    },
    next: function () {
      let a = document.getElementById("articles").scrollLeft;
      a += 600;
      document
        .getElementById("articles")
        .scroll({ left: a, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
/* .container {
  position: relative;
}
.slider {
  border: 1px solid #707070;
  background-color: rgba(28, 37, 49, 0.65);
  padding: 10px;
  border-radius: 10px;
  height: 20px;
  width: 20px;
}
.slider::after {
  font-size: 16px !important;
}

.articles {
  margin-top: 30px;
  border: 1px solid #738092;
  border-radius: 10px;
  padding: 10px 0;
}
.article {
  padding: 0 10px;
}

.article-item {
  margin: 0;
  position: relative;
}

.article-img {
  margin: 0;
}
.image {
  vertical-align: top;
  border-radius: 10px;
  width: 390px;
  height: 209px;
  object-fit: cover;
  cursor: pointer;
}
.article--title {
  width: calc(100% - 10px);
  position: absolute;
  top: 65%;
  left: 0;
  padding: 0px 15px;
  background-color: rgba(0, 0, 0, 0.7);
  height: 40%;
}
.article--title > p {
  white-space: normal;
  font-size: 1rem;
}


.carousel {
  overflow: scroll;
  position: relative;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
  padding-bottom: 10px;
  margin-top: 15px;
}

.carousel__container:hover .carousel-item:hover {
  -webkit-transform: scale(1.01);
  transform: scale(1.01);
  opacity: 1;
}

.carousel-item {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-carousel {
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  bottom: 120px;
  height: 40px;
  width: 40px;
  border: 1px solid #707070;
  background-color: rgba(28, 37, 49, 0.65);
  padding: 10px;
  border-radius: 10px;
  color: rgba(252, 252, 252, 0);
}
.icon-carousel:hover {
}

.icon-prev {
  left: 0px;
}

.icon-next {
  right: 0px;
}

@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .linea {
    font-size: 18px;
  }
  h3.linea:before {
    width: 75%;
    left: 20%;
  }
  .image {
    border-radius: 15px;
    width: 340px;
    height: 182px;
  }
  .articles {
    padding: 20px;
  }
  .article--title {
    width: 315px;
  }
}

@media (max-width: 600px) {
  .image {
    border-radius: 15px;
    width: 300px;
    height: 161px;
  }
  h3.linea:before {
    width: 50%;
    left: 50%;
  }
  .articles {
    padding: 10px;
  }

  .article--title {
    width: 275px;
  }
} */
.container {
  position: relative;
}

.title-linea {
  margin-top: 35px;
  width: 100%;
  display: flex;
  height: 70px;
  column-gap: 20px;
  align-items: top;
}

.title {
  align-self: center;
  white-space: nowrap;
  font-size: 1.2em;
}
.linea {
  width: 100%;
  height: 50%;
  border-bottom: 1px solid #738092;
}

.articles {
  margin-top: 30px;
  border: 1px solid #738092;
  padding: 10px 0;
  margin-top: 30px;
  border-radius: 20px;
}

.articles-area {
  position: relative;
  display: flex;
  justify-content: space-evenly;
  column-gap: 20px;
  row-gap: 20px;
  flex-wrap: wrap;
}
.articles-item {
  cursor: pointer;
  width: 190px;
}
.articles-item-img {
  display: flex;
  justify-content: center;
}
.articles-item-img > figure > img:hover {
  opacity: 0.7;
}
.articles-item-img > figure > img:active {
  opacity: 0.7;
  width: 99%;
}
.articles-item-img > figure {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: 80%;
}

.slider {
  border: 1px solid #707070;
  background-color: rgba(28, 37, 49, 0.65);
  padding: 10px;
  border-radius: 10px;
  height: 20px;
  width: 20px;
}
.slider::after {
  font-size: 16px !important;
}

.no-bottom {
  padding-bottom: 0;
  margin-bottom: 0;
}
.mtop-15 {
  margin-top: 15px;
}
h2 {
  font-weight: 400;
  border-bottom: 1px solid #738092;
}
.article {
  padding: 0 10px;
}

.article-item {
  margin: 0;
  position: relative;
}

.article-img {
  margin: 0;
}
.image {
  vertical-align: top;
  border-radius: 15px;
  width: 200px;
  height: 149px;
  object-fit: cover;
  cursor: pointer;
}
.article--title {
  width: 100%;
  position: absolute;
  top: 70%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  height: 30%;
  border-radius: 0px 0px 15px 15px;
}
.article--title > p {
  white-space: normal;
  font-size: 0.8rem;
  padding: 0 15px 5px 15px;
  white-space: nowrap;
  overflow-y: hidden;
  text-overflow: ellipsis;
}

.title {
  align-self: center;
  white-space: nowrap;
  font-size: 1.2em;
}
/* CAROUSEL */
.carousel-top,
.carousel-bottom {
  position: relative;
}
.carousel {
  overflow: scroll;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
}

.carousel__container:hover .carousel-item:hover {
  -webkit-transform: scale(1.01);
  transform: scale(1.01);
  opacity: 1;
}

.carousel-item {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
  height: 152px;
}

.carousel-subitem {
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-carousel {
  /* background: rgba(0, 0, 0, 0);
  border: 0px solid #9e9e9e;
  padding: 5px;*/
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  top: 100px;
  height: 40px;
  width: 40px;
  border: 1px solid #707070;
  background-color: rgba(28, 37, 49, 0.65);
  padding: 10px;
  border-radius: 10px;
  color: rgba(252, 252, 252, 0);
}
.icon-carousel:hover {
}

.icon-prev {
  left: 0px;
}

.icon-next {
  right: 0px;
}

.item-active {
  border: 2px solid white;
  border-radius: 20px;
}
.article--div {
  position: relative;
}
.horizontal-line-white {
  overflow-x: visible;
  visibility: visible;
  border-left: 2px solid white;
  height: 80px;
  position: absolute;
  left: 50%;
  top: 153px;
  width: 10px;
  z-index: 999999;
}
.article--item {
  position: relative;
  border-radius: 20px;
}

/* .carousel-enter-active,
.carousel-leave-active {
  transition: all 1s;
}
.carousel-enter, .carousel-leave-to  {
  opacity: 0;
  transform: translateX(-200px);
  transition-duration: 200;
} */

.carousel-enter-active {
  animation: carousel 0.5s;
}
.carousel-leave-active {
  animation: carousel 0.5s reverse;
}

@keyframes carousel {
  0% {
    opacity: 0;
    left: -100%;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}

@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .linea {
    font-size: 18px;
  }
  h3.linea:before {
    width: 75%;
    left: 20%;
  }
  .image {
    border-radius: 15px;
    width: 244px;
    height: 182px;
  }
  .articles {
    padding: 20px 20px 0 20px;
  }
  .article--title {
    width: 315px;
  }
}

@media (max-width: 600px) {
  .image {
    border-radius: 15px;
    width: 244px;
    height: 182px;
  }
  h3.linea:before {
    width: 50%;
    left: 50%;
  }
  .articles {
    padding: 10px;
  }

  .article--title {
    width: 275px;
  }
}
</style>
